angular.module('cfn').factory('fertiwebCodeService', [
  '$log',
  '$http',
  '$q',
  function ($log, $http, $q) {
    'use strict';

    // Private
    var URL = '/365FarmNet/mod/catalog-service/rest/v1.1/fertilizers/fertiweb/mappingtable';

    var loadMappingTable = function () {
      const response = $http.get(URL);
      return response;
    };

    // Public
    return ({
      loadMappingTable: loadMappingTable,
    });
  },
]);
